<template>
	<div class="audio-player" ref="player">
		<!-- <VDropdown>
		  <button>Click me</button>

		  <template #popper>
		    <a v-close-popper>Close</a>
		  </template>
		</VDropdown> -->

		<!-- <VDropdown :shown="isModalShown">
			<template #popper>
			    <span style="color: #fff;">Click the play icon on the tape recorder to start the audio.</span>
			</template>
		</VDropdown> -->

		<div @click.prevent="playPause" class="controls-mobile"></div>
		<audio playsinline v-bind:src="file" ref="audio" preload="auto"></audio>
		<div class="time-remaining">{{ privateData.timeRemaining }}</div>
		<div class="progress" ref="bar">
			<div class="bar">
				<div class="dot" ref="progress"></div>
			</div>
		</div>
		<div class="player-controls">
			<a v-if="privateData.playing === false" @click.prevent="play" href="/">
				<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 0 24 24" width="32px" fill="#FFFFFF">
					<path d="M0 0h24v24H0z" fill="none" />
					<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
				</svg>
			</a>
			<a v-if="privateData.playing === true" @click.prevent="pause" href="/">
				<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="32px" viewBox="0 0 24 24"
					width="32px" fill="#FFFFFF">
					<g>
						<rect fill="none" height="24" width="24" />
					</g>
					<g>
						<g>
							<path
								d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M11,16H9V8h2V16z M15,16h-2V8h2V16z" />
						</g>
					</g>
				</svg>
			</a>
		</div>


		<div class="loader" ref="loader">
			<svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
				y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
				<circle fill="#fff" stroke="none" cx="6" cy="50" r="6">
					<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1" />
				</circle>
				<circle fill="#fff" stroke="none" cx="26" cy="50" r="6">
					<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2" />
				</circle>
				<circle fill="#fff" stroke="none" cx="46" cy="50" r="6">
					<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3" />
				</circle>
			</svg>
		</div>
	</div>
</template>


<script>
import helpers from '../util/helpers';
import { createTooltip, destroyTooltip } from 'floating-vue'

const component = {
	name: 'AudioPlayer',
	props: {
		file: String,
		srt: String,
		id: String,
	},
	emits: [
		'player_play'
	],
	watch: {
		file: {
			handler(newVal) {
				if (newVal && newVal.length) {
					this.update();
				} else {
					this.destroy();
				}
			}
		}
	},
	data() {
		return {
			privateData: {
				timeRemaining: '0:00',
				progress: 0,
				playing: false,
				pixelPercentKoef: 0,
				progressBarRect: null,
			},
			progress: {
				dragstart: false
			},
			tooltip: null
		}
	},
	mounted() {
		const self = this;
		this.init();

		this.emitter.on('auto-play', timeout => {
			console.log('auto-play event fire')
			setTimeout(() => {
				self.play();
			}, 10);
		});

		this.progressBarRect = this.$refs.bar.getBoundingClientRect();

		this.$refs.progress.addEventListener('mousedown', this.progressStart);

		document.querySelector('body').addEventListener('mouseup', self.stopDrag);
		document.querySelector('body').addEventListener('mouseleave', self.stopDrag);
		document.querySelector('body').addEventListener('mousemove', this.progressMove);

		this.tooltip = createTooltip(this.$refs.player, {
		    triggers: [],
		    content: 'Click the play icon on the tape recorder to start the audio.',
		    placement: 'right',
		    strategy: 'fixed',
		    popperClass: 'modal-tooltip'
		})
	},
	methods: {
		init() {
			if (this.file && this.file.length) {
				this.showLoader();
				if (window.innerWidth <= 600 || helpers.isIOS() || helpers.isAndroid()) {
					console.log('mobile');
					this.$refs.audio.addEventListener('loadedmetadata', this.onReady);
				} else {
					console.log('desktop');
					this.$refs.audio.addEventListener('loadeddata', this.onReady);
				}
				this.$refs.audio.addEventListener('ended', this.finishPlayback);
				this.$refs.audio.addEventListener('pause', this.audioPauseHandler);
				this.$refs.audio.addEventListener('play', this.audioPlayHandler);
			}
		},
		progressStart() {
			this.progress.dragstart = true;
			this.progressBarRect = this.$refs.bar.getBoundingClientRect();
			this.pixelPercentKoef = 100 / this.progressBarRect.width;
		},
		progressMove(e) {
			if (this.progress.dragstart) {
				const left = e.clientX - this.progressBarRect.left;
				if (left > 0 && e.clientX < this.progressBarRect.right) {
					this.$refs.progress.style = `left: ${left}%`;
					this.$refs.audio.currentTime = (this.$refs.audio.duration / 100) * left * this.pixelPercentKoef;
				}
			}
		},
		playPause() {
			if (this.privateData.playing) {
        this.pause();
			} else {
        this.play();
			}
		},
		play() {
			console.debug('on play');
			if (this.$refs.audio) {
				console.debug('on play audio exists', this.$refs.audio);
				this.$refs.audio.play()
					.then(() => {
						console.debug('on play audio exists, promise ok');
						this.privateData.playing = true;
					}).catch(e => {
						console.debug('no interaction');
						this.tooltip.show(); 

						setTimeout(() => {
							this.tooltip.hide();
						}, 10000);
					});
			}
		},
		pause() {
			if (this.$refs.audio) {
				this.$refs.audio.pause();
				this.audioPauseHandler();
			}
		},
		audioPlayHandler() {
			this.privateData.playing = true;
			this.tooltip.hide();
		},
		audioPauseHandler() {
			this.privateData.playing = false;
		},
		stopDrag() {
			this.progress.dragstart = false;
		},
		onReady() {
			this.hideLoader();
			let timeDiff = this.$refs.audio.duration;
			this.privateData.timeRemaining = helpers.timeFormat(timeDiff);
			this.$refs.audio.addEventListener('timeupdate', this.onTimeUpdate);
			this.emitter.emit('player-ready');
		},
		onTimeUpdate() {
			if (this.$refs.audio !== undefined && this.$refs.audio !== null) {
				const timeDiff = this.$refs.audio.duration - this.$refs.audio.currentTime;
				this.privateData.timeRemaining = helpers.timeFormat(timeDiff);
				this.privateData.progress = helpers.progress(Math.round(this.$refs.audio.duration), Math.round(this.$refs.audio.currentTime));
				this.$refs.progress.style = `left: ${this.privateData.progress}%;`;
				this.emitter.emit('audio-time-change', this.$refs.audio.currentTime);
			}
		},
		destroy() {
			this.$refs.audio.removeEventListener('loadeddata', this.onReady);
			this.$refs.audio.removeEventListener('loadedmetadata', this.onReady);
			this.$refs.audio.removeEventListener('timeupdate', this.onTimeUpdate);
			this.$refs.audio.removeEventListener('ended', this.finishPlayback)
			this.$refs.audio.removeEventListener('pause', this.audioPauseHandler);
			this.$refs.audio.removeEventListener('play', this.audioPlayHandler);

			this.privateData.progress = 0;
			this.privateData.timeRemaining = '0:00';
			this.privateData.playing = false;
			this.hideLoader();
		},
		update() {
			console.log('!update')
			this.destroy();
			this.init();
		},
		showLoader() {
			this.$refs.loader.style.display = 'block';
		},
		hideLoader() {
			this.$refs.loader.style.display = 'none';
		},
		finishPlayback() {
			console.log('finish playback')
			this.emitter.emit('audio-playback-finish');
			helpers.enableScrolling();
		},
	},
	beforeUnmount() {
		this.emitter.all.clear();
		this.destroy();
		document.querySelector('body').removeEventListener('mouseup', this.stopDrag);
		document.querySelector('body').removeEventListener('mouseleave', this.stopDrag);
		this.$refs.progress.removeEventListener('mousedown', this.progressStart);
		document.querySelector('body').removeEventListener('mousemove', this.progressMove);
	}
}
export default component;
</script>

<style lang="scss" scoped>
$progress-color: #FFFFFF;

.audio-player {
	height: 100%;
	position: relative;
}

.controls-mobile {
	position: absolute;
	top: 15px;
	right: 15px;
	left: 15px;
	bottom: 15px;
	z-index: 2;
	display: none;
}

@media screen and (max-width: 750px) {
	.controls-mobile {
		display: block;
	}
}

.progress {
	position: relative;

	.bar {
		width: 100%;
		border: 1px solid $progress-color;
	}

	.dot {
		position: absolute;
		pointer-events: none;

		&:after {
			content: "";
			pointer-events: all;
			background-color: $progress-color;
			position: absolute;
			right: -5px;
			bottom: -5px;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			cursor: ew-resize;
		}
	}
}

.loader {
	width: 115px;
	height: 140px;
	position: absolute;
	left: 98px;
	top: 55px;
	transform: rotate(-2deg);
	display: none;
}
</style>
